// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { selectValue } from "#/admin/legacy/sp-select/index.js";
import { settleMount } from "#ce/framework/mount-ready";

/**
 * Selects `component`'s saved choice in the tool's sp-select and saves defined picks.
 * A change with an `undefined` value restores the previous selection without saving.
 * Resolves to the change listener, or `undefined` when the select fails to mount.
 */
export async function bindSelectTool(element, component) {
  const select = element.querySelector("sp-select");

  if (!(await settleMount(select))) {
    return;
  }

  select.value = selectValue(select.items, component.context);
  let previousSelection = select.value;

  function saveSelection(event) {
    if (event.target.value === undefined) {
      select.value = previousSelection;
      return;
    }

    component.save(event.target.value);
    component.render();
    select.value = selectValue(select.items, component.context);
    previousSelection = select.value;
  }

  element.addEventListener("change", saveSelection);

  return saveSelection;
}
